import { render, staticRenderFns } from "./cSwitcher.vue?vue&type=template&id=d428bea8&scoped=true&lang=pug"
import script from "./cSwitcher.vue?vue&type=script&lang=js"
export * from "./cSwitcher.vue?vue&type=script&lang=js"
import style0 from "./cSwitcher.vue?vue&type=style&index=0&id=d428bea8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d428bea8",
  null
  
)

export default component.exports